import { AuthUser } from '@/entities/authUser.entity';
import { MitreFilter } from '@/entities/mitreFilters.entity';
import { AuditLogPeriod } from '@/entities/auditLogPeriods.entity';
import { DashboardPeriod } from '@/entities/dashboardPeriods.entity';
import { ImpersonationStore } from '@/stores/impersonation.store.types';
import { StorageType, createStorageHandler } from '@/utils/storage.utils';
import { ModuleStateStore } from '@/entities/moduleState.entity';
import { PartnerTenantState } from '@/entities/partnerTenantState.entity';

export const authUserStorage = createStorageHandler<AuthUser>('authUser', StorageType.LocalStorage);

// Last real user-activity timestamp (epoch ms). LocalStorage so the idle clock
// is shared across tabs automatically; the inactivity monitor polls it.
export const lastActivityStorage = createStorageHandler<number>('lastActivity', StorageType.LocalStorage);

export const dashboardPeriodStorage = createStorageHandler<DashboardPeriod>(
  'dashboardPeriod',
  StorageType.SessionStorage,
);

export const auditLogPeriodStorage = createStorageHandler<AuditLogPeriod>('auditLogPeriod', StorageType.SessionStorage);

export const mitreFilterStorage = createStorageHandler<MitreFilter>('mitreFilters', StorageType.SessionStorage);

export const impersonationStorage = createStorageHandler<ImpersonationStore>('impersonation', StorageType.LocalStorage);

export const moduleStateStorage = createStorageHandler<ModuleStateStore>(
  'moduleStateStorage',
  StorageType.SessionStorage,
);

export const partnerTenantStateStorage = createStorageHandler<PartnerTenantState>(
  'partnerTenantStateStorage',
  StorageType.SessionStorage,
);

const trackingSessionStorage = createStorageHandler<string>('trackingSessionId', StorageType.SessionStorage);

export const getSessionId = (): string => {
  const existing = trackingSessionStorage.get();
  if (existing) return existing;
  const newId = crypto.randomUUID();
  trackingSessionStorage.set(newId);
  return newId;
};
